import React from 'react';

import ProgConfiguration from 'components/Tvendo/Distribution/Operations/ConfigProgramming/List';

export default function () {
  return <ProgConfiguration />;
}